import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employees-payroll-amount',
  templateUrl: './employees-payroll-amount.component.html',
  styleUrls: ['./employees-payroll-amount.component.scss']
})
export class EmployeesPayrollAmountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
